module.exports = __webpack_public_path__ + "static/media/bike transport from hyderabad to bangalore.54f433b9.jpg";